<template>
  <pessoa-box class="box-actions-ativo"
              @dragenter.native.prevent.stop="app = 'arquivos'"
              @dragover.native.prevent.stop="app = 'arquivos'">
    <pessoa-aba-header :active="app" @changeApp="changeApp" />
    <!---->

    <div class="cont-bodyAll">

      <component v-bind:is="currentTabComponent" :parse-props="parseProps" :app-methods="tabMethods" class="ativo"></component>
      <div class="itemAba"></div><!-- END Observações -->
      <div class="itemAba"></div><!-- END Atividade -->
      <div class="itemAba"></div><!-- END Sugerir horários -->

      <div class="itemAba">
        <!---->
      </div>

      <div class="itemAba"></div><!-- END E-mail -->
      <div class="itemAba"></div><!-- END Arquivos -->
    </div>
  </pessoa-box>
</template>

<script>
import Vue from 'vue'
import Mixin from './mixin'
import PessoaBox from "@/components/pessoa/components/include/pessoa/Box"
import PessoaAbaHeader from "@/components/negocio/components/includes/AbaHeader"
import {processoApps} from "@/components/negocio/components/includes/apps/appList"


for (let app in processoApps) {
  Vue.component(processoApps[app].name, processoApps[app].component)
}
// Vue.component(processoApps.observacoes.name, processoApps.observacoes.component)
// Vue.component(processoApps.atividade.name, processoApps.atividade.component)

export default {
  name: "NegocioAbas",
  mixins: [Mixin],
  components: {
    PessoaAbaHeader,
    PessoaBox
  },
  data () {
    return {
      app: processoApps.observacoes.name,
      parseProps: {
        pessoa: this.negocio, // Fake
        autoSelect: {
          pessoa: this.negocio.pessoa,
          negocio: this.negocio,
        },
        negocio: this.negocio,
        contatos: []
        // entidade: 'negocio',
        // entidadeId: this.negocio.id
      }
    }
  },
  computed: {
    currentTabComponent: function () {
      return this.app
    },
    tabMethods () {
      if (typeof processoApps[this.currentTabComponent] !== 'undefined') {
        return processoApps[this.currentTabComponent].methods
      }
      return null
    },
    processoContatos () {
      let contatos = []
      if (this.negocio.pessoa) {
        const pessoa = this.negocio.pessoa
        pessoa && !contatos.find((p) => p.id === pessoa.id) && contatos.push({
          ...pessoa,
          default: true
        })
      }
      return contatos
    }
  },
  methods: {
    changeApp (name) {
      this.parseProps.contatos = []
      if (name === 'contatos') {
        this.parseProps.contatos = this.processoContatos
      }
      console.log('Change app to ', name)
      this.app = name
    }
  }
}
</script>
